module.exports = __webpack_public_path__ + "static/media/NoImage.af879c88.jpg";